import React, { useCallback, useEffect, useState } from 'react'
import { connect as connectRedux } from 'react-redux'
import compose from 'recompose/compose'
import _get from 'lodash/get'
import { List, Map } from 'immutable'
import { getBoundActions } from '../../actions/index'
import { connect as connectStaticText } from '../StaticText/connect'
import {
  getSessionTimeout,
  getActiveSession,
  hasFreeSession as getHasFreeSession,
  isAmaAllowAnonymousWatch,
} from '../../services/live-access-events/index'
import { LIVE_ACCESS_SUBSCRIPTION_CODE } from '../../services/live-access-events/constants'
import { URL_PLAN_SELECTION } from '../../services/url/constants'
import { PLAN_SKU_INCREASED_PRICE_GAIA_PLUS } from '../../services/plans/index'
import { TYPE_MY_ACCOUNT_CHANGE_PLAN_CONFIRM } from '../../services/dialog/index'
import { useGetPlanDataBySku } from '../../services/plans/hooks'
import { get as getConfig } from '../../config/index'
import LiveExperience from './LiveExperience'
import Countdown from './Countdown'
/* import Preview from './Preview' */
import PreviewDone from './PreviewDone'

const config = getConfig()
const planGraphQLActive = !!_get(config, ['features', 'checkout', 'planGraphQL'])

function dhm (ms) {
  const days = Math.floor(ms / (24 * 60 * 60 * 1000))
  const daysms = ms % (24 * 60 * 60 * 1000)
  const hours = Math.floor((daysms) / (60 * 60 * 1000))
  const hoursms = ms % (60 * 60 * 1000)
  const minutes = Math.floor((hoursms) / (60 * 1000))
  const minutesms = ms % (60 * 1000)
  const sec = Math.floor((minutesms) / (1000))
  return `${days} days ${hours} hours ${minutes} minutes ${sec} seconds`
}

// eslint-disable-next-line no-unused-vars
const Debug = (props) => {
  const {
    isAnonymous, hasEntitlements,
    nowTs, isLive, isLiveAccessMember, eventDetails, videoEnded,
    livePlaybackUrl, timeout,
  } = props
  const username = props.auth && props.auth.get('username')
  const schedule = eventDetails && eventDetails.getIn(['tracks', 0, 'schedule'])
  const eventId = eventDetails && eventDetails.getIn(['id'])
  const sessions = schedule && schedule.toJS()
  const sessionId = _get(getActiveSession(sessions, nowTs), 'id')
  const isFreeSession = _get(getActiveSession(sessions, nowTs), 'isFree') !== false
  const previewUrl = eventDetails && eventDetails.get('previewUrl')
  return (
    <pre>
      {isAnonymous && <div>I am anonymous user</div>}
      {username && <div>I am {username} with subscriptions: {props.auth && props.auth.get('subscriptions').toJS().join(':')}</div>}
      Has Entitlements: {String(hasEntitlements)}<br />
      <div>Session is {!isFreeSession && 'not'} free</div>
      <div>Event id: {eventId}</div>
      <div>ActiveSessionId is {sessionId} </div>
      <div>Refresh in {dhm(timeout)}</div>
      I am {!isLiveAccessMember && <span>not</span>} an Gaia+ member
      <div>Live URL {livePlaybackUrl}</div>
      <div>Preview URL {previewUrl}</div>
      <div>PreviewPlay is {!videoEnded && 'not'} complete</div>
      nowTs: {new Date(nowTs).toLocaleString()}<br />
      live: {String(isLive)}<br />
    </pre>
  )
}

const LivePage = (props) => {
  const {
    language,
    nowTs,
    eventDetails,
    livePlaybackUrl,
    userAccount,
    auth,
    getLiveAccessSessionDetails,
    // eslint-disable-next-line no-unused-vars
    getLiveAccessNextEvent, isLive, debug, isCountdown,
    isLiveAccessMember, isFreeSession, isLiveOverride, isPublicStream,
    hasFreeSession, staticText, setPlanChangeSelected, renderModal,
    eventType = 'LIVE', // Default to 'LIVE' for backward compatibility
    isAnonymous,
    hasEntitlements,
    path,
  } = props
  const [isReady, setIsReady] = useState(false)
  // Reset ready state when eventType changes (e.g., when switching routes)
  useEffect(() => {
    setIsReady(false)
  }, [eventType])
  const userPlanSku = userAccount.getIn(['details', 'data', 'billing', 'subscriptions', 'plan', 'planSku'])
  const gqlPlanData = useGetPlanDataBySku({
    userLanguage: language,
    authJwt: auth.get('jwt'),
    planSkus: PLAN_SKU_INCREASED_PRICE_GAIA_PLUS,
  }) || Map()
  const gaiaPlusPlan = gqlPlanData.get('plans', List()).first()
  const gaiaPlusPlanComplete = gqlPlanData.get('complete', false)
  const gqlUserPlanData = useGetPlanDataBySku({
    userLanguage: language,
    authJwt: auth.get('jwt'),
    planSkus: userPlanSku,
    forceRefresh: true,
  }) || Map()
  const userPlanComplete = gqlUserPlanData.get('complete', false)
  const userPlanData = gqlUserPlanData.get('plans', List()) || List()
  const currentPlan = userPlanData.get(0) || Map()
  useEffect(() => {
    getLiveAccessNextEvent({
      language,
      isLiveOverride,
      nowTs,
      eventType,
    })
  }, [language, eventType, isLiveOverride])
  useEffect(() => {
    // Only set ready if we have eventDetails that match our eventType
    if (eventDetails) {
      setIsReady(true)
    } else {
      // Reset ready state if eventDetails doesn't match or is cleared
      setIsReady(false)
    }
  }, [eventDetails, eventType])
  useEffect(() => {
    if (isLive && eventDetails && !livePlaybackUrl) {
      const tracks = eventDetails.get('tracks')
      if (tracks) {
        tracks.forEach((track) => {
          getLiveAccessSessionDetails({ id: track.getIn(['schedule', 0, 'id']), language })
        })
      }
    }
  }, [language, isLive, eventDetails, livePlaybackUrl, getLiveAccessSessionDetails])

  const onClickAccountChangePlan = (plan, userCurrentPlan) => {
    setPlanChangeSelected(plan)
    renderModal(TYPE_MY_ACCOUNT_CHANGE_PLAN_CONFIRM, {
      hideDismiss: false,
      ...(planGraphQLActive && { currentPlan: userCurrentPlan }),
    })
  }

  const reloadEvent = useCallback(() => {
    getLiveAccessNextEvent({
      language,
      isLiveOverride,
      eventType,
    })
  }, [language, isLiveOverride, eventType, getLiveAccessNextEvent])
  if (!isReady) {
    return null
  }
  if (isCountdown) {
    return <Countdown />
  }
  const isAMARoute = eventType === 'AMA' || path === '/ama'
  const allowAmaAnonymous = isAMARoute && isAmaAllowAnonymousWatch(eventDetails, nowTs)
  if (isAnonymous && isAMARoute && !hasEntitlements && !allowAmaAnonymous) {
    return (<PreviewDone
      line1={staticText.getIn(['data', 'amaGateLine1'])}
      line2={staticText.getIn(['data', 'amaGateLine2'])}
      joinUrl={URL_PLAN_SELECTION}
      joinQuery={null}
    />)
  }
  const skipAnonFreeSessionGate = isAnonymous && allowAmaAnonymous
  if (!isLiveAccessMember && !isPublicStream && !skipAnonFreeSessionGate) {
    if (!hasFreeSession || !isFreeSession) {
      return (<PreviewDone
        line1={staticText.getIn(['data', 'anonCLELine1'])}
        line2={staticText.getIn(['data', 'anonCLELine2'])}
        onClickUpgrade={
          () => {
            // Try to proceed even if plan data isn't fully loaded
            if (gaiaPlusPlanComplete && userPlanComplete) {
              onClickAccountChangePlan(gaiaPlusPlan, currentPlan)
            } else if (gaiaPlusPlan && gaiaPlusPlan.size > 0) {
              onClickAccountChangePlan(gaiaPlusPlan, currentPlan)
            }
          }
        }
      />)
    }
    /*  if (!isFreeSession) {
      return <Preview />
    } */
  }
  return <LiveExperience reloadEvent={reloadEvent} />
}

export default compose(
  connectRedux(
    (state, ownProps) => {
      const language = state.user.getIn(['data', 'language', 0], 'en')
      const eventType = ownProps.eventType || 'LIVE'
      const rawEventDetails = state.liveAccessEvents.getIn(['eventDetails', language,
        'data', 'event'])
      // Only use eventDetails if it matches our eventType
      const eventDetails = rawEventDetails && rawEventDetails.get('type') === eventType
        ? rawEventDetails
        : null
      const eventId = eventDetails && eventDetails.get('id')
      const sessionId = eventDetails && eventDetails.getIn(['tracks', 0, 'schedule', 0, 'id'])
      const isPublicStream = eventDetails && eventDetails.get('publicStream')
      const isAnonymous = !state.auth.get('username')
      const hasEntitlements = state.auth.get('subscriptions') && state.auth.get('subscriptions').size > 0
      const query = state.resolver.get('query')
      const { timenow } = query.toJS()
      const nowTs = timenow ? Date.parse(timenow) : (new Date()).getTime()
      // Only show countdown if eventDetails matches our eventType
      // Use rawCountdown only if the event type matches, otherwise treat as no countdown
      const rawCountdown = state.liveAccessEvents.getIn(['eventDetails', language, 'data', 'countdown'])
      const isCountdown = eventDetails
        && rawEventDetails && rawEventDetails.get('type') === eventType
        && !Number.isNaN(rawCountdown)
        && rawCountdown !== 0
      const schedule = eventDetails && eventDetails.getIn(['tracks', 0, 'schedule'])
      const sessions = schedule && schedule.toJS()
      const timeout = getSessionTimeout(sessions, nowTs)
      const isLiveOverride = state.resolver.getIn(['query', 'liveoverride'], undefined)
      const isFreeSession = _get(getActiveSession(sessions, nowTs), 'isFree') !== false
      return {
        isCountdown,
        isAnonymous,
        user: state.user,
        isLiveOverride,
        isLive: !isCountdown,
        language,
        hasEntitlements,
        hasFreeSession: getHasFreeSession(sessions),
        timeout,
        sessionId,
        query,
        nowTs,
        livePlaybackUrl: state.liveAccessEvents.getIn(['sessionDetails', sessionId,
          language, 'data', 'session', 'playbackUrl']),
        haveEmail: state.resolver.getIn(['query', 'haveEmail']) === 'true',
        auth: state.auth,
        app: state.app,
        debug: state.resolver.getIn(['query', 'debug']) === 'true',
        isLiveAccessMember: !!state.auth.get('subscriptions') && state.auth.get('subscriptions').includes(LIVE_ACCESS_SUBSCRIPTION_CODE),
        videoEnded: state.videoPlayer.get('ended'),
        liveAccessEvents: state.liveAccessEvents,
        eventsList: state.liveAccessEvents.getIn(['eventsList',
          language,
          'data', 'events']),
        path: state.resolver.get('path'),
        eventDetails,
        eventId,
        isFreeSession,
        isPublicStream,
        userAccount: state.userAccount,
      }
    },
    (dispatch) => {
      const actions = getBoundActions(dispatch)
      return {
        setPageSeo: actions.page.setPageSeo,
        getLiveAccessSchedule: actions.liveAccessEvents.getLiveAccessSchedule,
        getLiveAccessSessionDetails: actions.liveAccessEvents.getLiveAccessSessionDetails,
        getLiveAccessNextEvent: actions.liveAccessEvents.getLiveAccessNextEvent,
        setOverlayDialogVisible: actions.dialog.setOverlayDialogVisible,
        setPlanChangeSelected: actions.plans.setPlanChangeSelected,
        renderModal: actions.dialog.renderModal,
      }
    },
  ),
  connectStaticText({ storeKey: 'livePage' }),
)(LivePage)
